import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { AdminStudioListItem } from "@shared-kernel/application/ports/admin/admin-repository";

export const retrieveAdminStudios = createAsyncThunk<AdminStudioListItem[], void, { extra: Partial<Dependencies> }>(
  "admin/studios/retrieve",
  async (_, { extra: { adminRepository } }) => {
    return adminRepository!.listStudios();
  },
);
